import React from 'react';
import { Card } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import CardItem from '@/components/cards/CardItem';
import NotificationTools from './NotificationTools';

const NotificationCardItem = ({
  category,
  code,
  event,
  notification,
  onCheckBoxClick,
  showNotification,
  single,
  upward,
}) => {
  const intl = useIntl();
  return (
    <CardItem className="aridhia-notification-list-item">
      <NameDescriptionCard
        description={notification.description}
        href="#"
        icon="bell"
        markdown
        name={notification.name}
        entity="notification"
        selected={notification.selected}
        onClick={() => showNotification({ event, notificationCode: notification.code })}
        onSelect={onCheckBoxClick ? () => onCheckBoxClick(notification.code) : undefined}
        single={single}
        meta={intl.formatMessage({ id: 'notification.created.author' }, { name: notification.author.name })}
      >
        <NotificationTools
          category={category}
          code={code}
          event={event}
          notificationCode={notification.code}
          upward={upward}
          listItem
        />
      </NameDescriptionCard>
      <Card.Content extra content={notification.createdOn} />
    </CardItem>
  );
};

export default NotificationCardItem;
